(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-advanced"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const headerSelector = window.theme.settings.headerStickyType === 'common'?'.sections-header-wrapper':'.section-header-advanced';
      this.header = document.querySelector(headerSelector);
      this.headerIsAlwaysSticky = 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      // Measure again once the logo and fonts have loaded: measured before them on a slow first visit the header reads
      // 58px instead of 72px, and the see-through hero, pulled up by that amount, leaves a white band under the
      // announcement bar (Van 2026-10-23)
      const remeasure = this.setHeaderHeight.bind(this);
      this.header?.querySelectorAll('img').forEach((img) => {
        if (!img.complete) img.addEventListener('load', remeasure, { once: true });
      });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
      window.addEventListener('load', remeasure, { once: true });
      // ...and whenever the header changes height while the page is at the top: late styles, fonts, the logo and the
      // menu-fit script can all resize it after those moments, which brought the white band back (Van 2026-10-23).
      // Not while scrolled, so the page never shifts under the reader.
      if ('ResizeObserver' in window && this.header) {
        let lastHeight = this.header.offsetHeight;
        new ResizeObserver(() => {
          const height = this.header.offsetHeight;
          if (height === lastHeight) return;
          lastHeight = height;
          if (window.scrollY <= height) this.setHeaderHeight();
          else this.headerHeightStale = true;
        }).observe(this.header);
      }

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-advanced-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty('--product-grid-sticky-position', `${this.header.offsetHeight+30}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // The header changed height while the page was scrolled (window resized, menu refit): catch up once back at the
      // top, or the see-through banner sits that much lower and shows a white band under the announcement bar
      // (Van 2026-10-26, Charm Hoops page: 59px kept after widening the window, header 72px, 13px band)
      if (this.headerHeightStale && scrollTop <= this.header.offsetHeight) {
        this.headerHeightStale = false;
        this.setHeaderHeight();
      }

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-advanced-hidden', 'shopify-section-header-advanced-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-advanced-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-advanced-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-advanced-hidden', 'shopify-section-header-advanced-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
